/* Registers the minimal pass-through service worker required for PWA
   installability. Skipped in development and when running inside Capacitor. */

const isLocalhost = Boolean(
	typeof window !== "undefined" &&
		(window.location.hostname === "localhost" ||
			window.location.hostname === "[::1]" ||
			/^127(?:\.\d+){3}$/.test(window.location.hostname))
);

const isCapacitor = () => {
	if (typeof window === "undefined") return false;
	if (window.Capacitor && window.Capacitor.isNativePlatform && window.Capacitor.isNativePlatform()) return true;
	const proto = window.location && window.location.protocol;
	return proto === "capacitor:" || proto === "ionic:";
};

export function register() {
	if (typeof window === "undefined") return;
	if (!("serviceWorker" in navigator)) return;
	if (process.env.NODE_ENV !== "production") return;
	if (isCapacitor()) return;
	if (isLocalhost) return;

	window.addEventListener("load", () => {
		const swUrl = `${process.env.PUBLIC_URL || ""}/service-worker.js`;
		navigator.serviceWorker.register(swUrl).catch((err) => {
			console.warn("[PWA] service worker registration failed:", err);
		});
	});
}

export function unregister() {
	if (typeof window === "undefined") return;
	if (!("serviceWorker" in navigator)) return;
	navigator.serviceWorker.ready
		.then((registration) => registration.unregister())
		.catch(() => {});
}
